import type { ScraperParameterDefinition } from '../../api/cityConfig';

export default function ScraperParameterFields({
  definitions,
  parameters,
  onChange,
}: {
  definitions: ScraperParameterDefinition[];
  parameters: Record<string, unknown>;
  onChange: (key: string, value: unknown) => void;
}) {
  if (definitions.length === 0) {
    return <p className="text-sm text-gray-500">Für diese Kategorie sind keine Parameter erforderlich.</p>;
  }

  return (
    <div className="space-y-5">
      {definitions.map((definition) => (
        <ParameterInput
          key={definition.key}
          definition={definition}
          value={parameters[definition.key]}
          onChange={(value) => onChange(definition.key, value)}
        />
      ))}
    </div>
  );
}

function ParameterInput({
  definition,
  value,
  onChange,
}: {
  definition: ScraperParameterDefinition;
  value: unknown;
  onChange: (value: unknown) => void;
}) {
  if (definition.type === 'boolean') {
    return (
      <label className="flex items-start gap-3">
        <input
          type="checkbox"
          checked={Boolean(value)}
          required={definition.required}
          onChange={(event) => onChange(event.target.checked)}
          className="mt-1"
        />
        <span>
          <span className="block text-sm font-medium text-gray-800">{definition.label}</span>
          {definition.description && <span className="block text-sm text-gray-500">{definition.description}</span>}
        </span>
      </label>
    );
  }

  return (
    <label className="block space-y-1.5">
      <span className="text-sm font-medium text-gray-800">
        {definition.label}{definition.required && <span className="text-red-600"> *</span>}
      </span>
      {definition.type === 'select' ? (
        <select
          value={String(value ?? '')}
          required={definition.required}
          onChange={(event) => onChange(event.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded bg-white"
        >
          <option value="" disabled={definition.required}>Bitte auswählen</option>
          {definition.options.map((option) => <option key={option} value={option}>{option}</option>)}
        </select>
      ) : (
        <input
          type={definition.type}
          value={String(value ?? '')}
          placeholder={definition.placeholder ?? undefined}
          required={definition.required}
          onChange={(event) => onChange(
            definition.type === 'number'
              ? (event.target.value === '' ? '' : Number(event.target.value))
              : event.target.value,
          )}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />
      )}
      {definition.description && <span className="block text-sm text-gray-500">{definition.description}</span>}
    </label>
  );
}